import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmBreadcrumbList]',
  host: {
    'data-slot': 'breadcrumb-list',
  },
})
export class HlmBreadcrumbList {
  constructor() {
    classes(
      () => 'flex flex-nowrap items-center list-none m-0 p-0 gap-[var(--ocp-breadcrumb-gap)]'
    );
  }
}
